import { API } from "API/API";
import { Constants } from "../../constants/constants";

const cat_by_id = async (id, cpt = false) => {
  const result = await API.get.wp("webshop/categories/get/" + id, null, {
    next: {
      tags: ["everything", "categories", "category_" + id],
      revalidate: 3600,
    },
  });

  if (result?.error) {
    console.error(result);
  }
  return result;
};

const all_cats = async (hierarchical = false) => {
  const result = await API.get.wp(
    "webshop/categories/get_all?hierarchical=" +
      (hierarchical ? "true" : "false"),
    null,
    { next: { tags: ["everything", "categories", "all_categories"] } }
  );

  if (result?.error) {
    console.error(result);
    return [];
  }
  if (Array.isArray(result?.data?.categories)) {
    return result.data.categories;
  }
  return [];
};

const all_properties = async () => {
  const result = await API.get.wp(
    "webshop/properties/get_all",
    null,
    { next: { tags: ["everything", "properties", "all_properties"] } }
  );

  if (result?.error) {
    console.error(result);
    return [];
  }
  if (Array.isArray(result?.data?.properties)) {
    return result.data.properties;
  }
  return [];
};

export const categories = {
  all: all_cats,
  byId: cat_by_id,
  filters: all_properties,
};
